import axiosInstance from "./AxiosInstance";

export const getCaseTags = () => {
  return axiosInstance.get(`/case-tags`);
};

export const addCaseTag = (data) => {
  return axiosInstance.post(`/case-tags`, data);
};

export const removeCaseTag = (data) => {
  return axiosInstance.delete(`/case-tags`, { data });
};